var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "propertyName",
    title: "Property Name",
    description: "Must be a valid variable/property name.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({}, "myProperty");
            }
        },
        invalidDash: {
            throw: "fields.propertyName.invalid",
            run: function () {
                return validate({}, "my-property");
            }
        },
        startsWithNumber: {
            throw: "fields.propertyName.invalid",
            run: function () {
                return validate({}, "123abc");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Property Name",
            description: "Must be a valid JavaScript property name.",
            template: "'${value}' is not a valid property name."
        }
    }
});

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ value: value });
    }

    if (!/^[$A-Z_][0-9A-Z_$]*$/i.test(value)) {
        _.errors.invalid.throw({ value: value });
    }
}
module.exports.validate = validate;
